module.exports = __webpack_public_path__ + "img/offer-right.894e4558.png";